module.exports = __webpack_public_path__ + "img/stamp-island-name-icons-flag.790c0fee.png";